import {Component, Input, OnInit, SimpleChanges, OnChanges, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'beaconstac-pagination',
  templateUrl: './paginations.component.html',
  styleUrls: ['./paginations.component.scss']
})
export class PaginationsComponent implements OnInit, OnChanges {
  /**
   * Page content
   */
  @Input()
  pageCount: number = 1;

  /**
   * Total row
   */
  @Input()
  totalResults: number = 70;

  /**
   * Page number change emitter
   */
  @Output() onPageChange: EventEmitter<number> = new EventEmitter();

  currentPage: number;
  currentChapter: number;
  pagesArray: number[] = [];
  beginningArray: number[] = [];
  middleArray: number[] = [];
  endingArray: number[] = [];
  chapterCount: number;
  chapterSize: number = 4;

  startPage: number;
  endPage: number;

  @Input()
  pageSize: number = 10
  paginationLength: number;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setupPaginationValues()
  }

  ngOnInit(): void {
  }

  changePage(number: number) {
    this.onPageChange.emit(number)
    // this.pageCount = number
    // this.setupPaginationValues()
  }

  private setupPaginationValues() {
    this.paginationLength = Math.ceil(this.totalResults / this.pageSize)
    if (this.paginationLength > 7) {

      if (this.pageCount <= 3) {
        this.beginningArray = [1, 2, 3, 4]
        this.middleArray = []
        this.endingArray = [this.paginationLength]
      } else if (this.pageCount <= this.paginationLength - 3) {
        this.beginningArray = [1]
        this.middleArray = [this.pageCount - 1, this.pageCount, this.pageCount + 1]
        this.endingArray = [this.paginationLength]
      } else {
        this.beginningArray = [1]
        this.middleArray = []
        this.endingArray = [this.paginationLength - 3, this.paginationLength - 2, this.paginationLength - 1, this.paginationLength]
      }

    } else {
      this.pagesArray = Array.from({length: this.paginationLength}, (_, i) => i + 1)
    }
  }
}
